// 媒体ごとのフリー (指名なし) スタッフ ID。nabeko (go/modules/nabeko/internal/domain/model/staff.go) の定義と揃える。
// スクレイピング結果や nabeko の置き換え (AssignFreeStaffForNonNominatedCancelSalonIDs) で
// staff_id にこれらが入り、staff_name は "フリー" 固定になる。
const FREE_STAFF_IDS: ReadonlySet<string> = new Set([
	"SALONBOARD_FREE_STAFF_ID",
	"EXCEED_SYSTEM_FREE_STAFF_ID",
	"POSTAS_FREE_STAFF_ID",
	"RAKUTEN_BEAUTY_FREE_STAFF_ID",
	"SALON_CONNECT_FREE_STAFF_ID",
	"KANZASHI_FREE_STAFF_ID",
	// beauty_merit のフリー
	"0",
])

export const FREE_STAFF_LABEL = "フリー（指名なし）"
export const NOMINATED_PREFIX = "【前回指名】"

export const isFreeStaffId = (staffId: string | null | undefined): boolean =>
	staffId != null && FREE_STAFF_IDS.has(staffId)

// 再予約画面で出すスタッフ名。フリーなら「フリー（指名なし）」、それ以外は媒体のスタッフ名をそのまま返す。
// フリーに【前回指名】を付けると「指名していないのに前回指名」と読めてしまうため、呼び出し側で接頭辞を付ける前にこれを通す。
export const staffDisplayName = (
	staffId: string | null | undefined,
	name: string | null | undefined
): string => {
	if (isFreeStaffId(staffId)) return FREE_STAFF_LABEL
	return name ?? ""
}

// 前回キャンセルの担当スタッフを「指名スタッフ」欄に出すときの文字列。
// - フリー: 「フリー（指名なし）」(接頭辞なし)
// - それ以外: 「【前回指名】{name}」
// 指名なし (is_nominated=false) の扱いは BE の feature flag (HIDE_STAFF_FOR_NOT_NOMINATED_RERESERVATION) で決まり、
// canceledReservation.hidesStaffDueToNotNominated=true のときは呼び出し側が欄ごと出さない。
export const originalStaffLabel = (
	staffId: string | null | undefined,
	name: string | null | undefined
): string => {
	if (isFreeStaffId(staffId)) return FREE_STAFF_LABEL
	return `${NOMINATED_PREFIX}${name ?? ""}`
}
